import { axios } from '@/api/common'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  ChangeOwnPasswordModel,
  ChangeOwnPasswordSchema,
  UserChangePasswordModel,
  UserChangePasswordSchema,
  UserCreateModel,
  UserUpdateModel,
  UserUpdateSchema,
} from './mutation.schema'

export async function createUser(data: UserCreateModel): Promise<void> {
  await axios.post('/api/masterdata/users', data)
}

export const useCreateUserMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: createUser,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['users'] })
    },
  })
}

export async function updateUser(data: UserUpdateModel): Promise<void> {
  const patch = UserUpdateSchema.parse(data)
  await axios.put(`/api/masterdata/users/${data.id}`, patch)
}

export const useUpdateUserMutation = (id: number) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['users', 'update', id],
    mutationFn: updateUser,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['users'] })
    },
  })
}

export async function changePassword(
  data: UserChangePasswordModel
): Promise<void> {
  const patch = UserChangePasswordSchema.parse(data)
  await axios.put(`/api/masterdata/change-password/${data.id}`, patch)
}

export const useChangePasswordMutation = (id: number) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['users', 'update', id],
    mutationFn: changePassword,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['users'] })
    },
  })
}

// =================  change own password =================

export async function changeOwnPassword(
  data: ChangeOwnPasswordModel
): Promise<void> {
  const payload = ChangeOwnPasswordSchema.parse(data)
  await axios.put('/api/masterdata/user/change-own-password', payload)
}

export const useChangeOwnPasswordMutation = () => {
  return useMutation({
    mutationFn: changeOwnPassword,
  })
}

// =================  delete party =================

export const useDeleteUserMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id: number) => axios.delete(`/api/masterdata/users/${id}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['users'] })
    },
  })
}
